import { ActivityModel } from "./Activity.model";

export class Activity extends ActivityModel {
    // Add custom methods here
}
